import React, { useEffect, useState } from "react";
import { DefaultToast, defaultToastIcons } from "components/Toast/DefaultToast";
import { useSchedulingABVariant } from "../utils/useSchedulingABVariant";

interface LoadingToastProps {
  isLoading: boolean;
}

export const LoadingToast: React.FC<LoadingToastProps> = ({ isLoading }) => {
  const isV3 = useSchedulingABVariant();
  const [isVisible, setVisible] = useState(false);
  useEffect(() => {
    let timeoutId: NodeJS.Timeout;

    if (isLoading) {
      timeoutId = setTimeout(() => setVisible(true), 5000);
    } else {
      setVisible(false);
    }

    return () => {
      timeoutId && clearTimeout(timeoutId);
    };
  }, [isLoading]);

  return (
    <DefaultToast
      visible={isVisible}
      sideIcon={<defaultToastIcons.Reload />}
      onDismiss={() => setVisible(false)}
      isV3={isV3}
    >
      <p>Hold tight while we complete your request.</p>
    </DefaultToast>
  );
};
